import { Component } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { TsButtonModule } from 'tsui';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Column, ICellRendererParams } from 'ag-grid-community';
import { TableColumn } from 'app/modules/projects/details/dashboard/panels/table/table.types';

declare type SumOrAvg = 'sum' | 'avg';

@Component({
  standalone: true,
  imports: [MatIconModule, TsButtonModule, MatMenuModule, TitleCasePipe],
  selector: 'related-table-core-agg-footer-renderer',
  template: `
    @if (params.colDef.field !== 'openDetails' && params.value) {
      <div class="footer-agg">
        <span>{{ params.value | titlecase }}</span>
        <button mat-icon-button [matMenuTriggerFor]="aggMenu">
          <mat-icon [svgIcon]="'expand_more'" class="icon-size-12"></mat-icon>
        </button>
        <mat-menu #aggMenu="matMenu">
          <button mat-menu-item (click)="toggleAgg('sum')">Sum</button>
          <button mat-menu-item (click)="toggleAgg('avg')">Avg</button>
        </mat-menu>
      </div>
    }
  `,
  styles: [
    `
      .footer-agg {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    `,
  ],
})
export class RelatedTableCoreAggFooterRendererComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  operation: SumOrAvg;
  column: Column<TableColumn>;
  columnDefContext: TableColumn;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.column = this.params.column;
    this.columnDefContext = this.column.getColDef().context;
    this.updateOperation(this.params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.updateOperation(this.params);
    return false;
  }

  private updateOperation(params: ICellRendererParams): void {
    const sumAndAvgs = params.context.sumAndAvgs;

    if (sumAndAvgs && this.columnDefContext) {
      const fieldName = this.columnDefContext.name;
      if (sumAndAvgs[fieldName]) {
        this.operation = sumAndAvgs[fieldName].display;
      }
    }
  }

  toggleAgg(operation: SumOrAvg): void {
    if (this.params.context && this.params.context.toggleSumOrAvg) {
      this.params.context.toggleSumOrAvg({ fieldDef: this.columnDefContext }, operation);
      this.operation = operation;

      if (this.params.api) {
        this.params.api.refreshCells({
          force: true,
          rowNodes: [this.params.node],
          columns: [this.params.column.getColId()],
        });
      }
    }
  }
}
